export enum OperationStatusEnum {
  NOT_STARTED = "NOT_STARTED",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  PARTIAL_COMPLETED = "PARTIAL_COMPLETED",
  CANCELLED = "CANCELLED"
}
